module.exports = __webpack_public_path__ + "b44fdaa126a3e23a01e0be300ce78ecd.svg";